import * as React from 'react'

const DeleteIcon = props => {
  const { color } = props
  return (
    <svg
      width={40}
      height={40}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={40} height={40} rx={4} fill={color || '#004360'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.334 13c0-.552.397-1 .889-1h3.555c.492 0 .89.448.89 1s-.398 1-.89 1h-3.555c-.492 0-.89-.448-.89-1Zm-1.067 13h7.466v-9h-7.466v9ZM24.8 15H13.067c-.59 0-1.067.448-1.067 1s.477 1 1.067 1h1.066v10c0 .552.477 1 1.067 1h9.6c.59 0 1.067-.448 1.067-1V17h1.066c.59 0 1.067-.448 1.067-1s-.477-1-1.067-1H24.8Z"
        fill="#fff"
      />
    </svg>
  )
}

export default DeleteIcon
